/**
 * Simple structured data generators for SEO
 */

const SITE_URL = 'https://landscapes.valeter.net';

/**
 * Website and Photographer structured data (homepage)
 */
export const getWebsiteStructuredData = () => ({
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Landscape and Nature Photography by ValeTer',
    url: SITE_URL,
    author: {
        '@type': 'Person',
        name: 'Valerii Tereshchenko',
        alternateName: 'ValeTer',
        jobTitle: 'Landscape Photographer',
        url: SITE_URL,
        sameAs: [
            'https://www.instagram.com/ValeTer_',
            'https://www.facebook.com/ValeTerPhotography',
            'https://bsky.app/profile/valeter.bsky.social',
        ],
    },
});

/**
 * Breadcrumb navigation
 */
export const getBreadcrumbStructuredData = (items) => {
    if (!items || items.length === 0) return null;

    return {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: items.map((item, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            name: item.name,
            item: item.url ? `${SITE_URL}${item.url}` : undefined,
        })),
    };
};

